import {
  TinyMCEData,
  TinyMCEMenuItem,
  TinyMCEMenuTemplate,
} from '@/types/editor'
import { headerTemplate } from '../templates/headerTemplate'
import { insertTemplate } from './insertTemplate'
import type { CasePreferences } from '@messenger/types'

type HeaderProperties = {
  key: keyof NonNullable<CasePreferences>
  label: string | keyof NonNullable<CasePreferences>
}

type InsertableHeadersProps = TinyMCEData & {
  headers: TinyMCEMenuTemplate[]
}

const headerProperties: HeaderProperties[] = [
  { key: 'birth_header', label: 'Birth Header' },
  { key: 'death_header', label: 'Death Header' },
  {
    key: 'remembrance_header',
    label: 'Remembrance Header',
  },
  {
    key: 'final_resting_header',
    label: 'Final Resting Header',
  },
  {
    key: 'officiating_header',
    label: 'Officiating Header',
  },
  {
    key: 'pallbearers_header',
    label: 'Pallbearers Header',
  },
  {
    key: 'visitation_header',
    label: 'Visitation Header',
  },
  {
    key: 'memorial_service_header',
    label: 'Memorial Service Header',
  },
  {
    key: 'family_appreciation_header',
    label: 'Family Appreciation Header',
  },
]

export const insertableHeaders = (editorProps: TinyMCEData) => {
  const headers: TinyMCEMenuTemplate[] = []
  const insertableProps = { ...editorProps, headers }

  handleHeaders(insertableProps)

  return headers
}

const handleHeaders = (insertableProps: InsertableHeadersProps) => {
  const { editor, headers, selectedTheme, caseDetails } = insertableProps
  const { case_preferences } = caseDetails || {}
  const hasCasePreferences = Object.keys(case_preferences || {}).length > 0

  if (!hasCasePreferences) return

  const headersMenu = {
    type: 'nestedmenuitem' as const,
    text: 'Headers',
    getSubmenuItems: () => {
      const items: TinyMCEMenuItem[] = []

      headerProperties.forEach(({ key, label }) => {
        const headerValue = case_preferences?.[key] || ''
        const headerHtml = headerTemplate({
          key,
          headerValue,
          selectedTheme: selectedTheme ?? null,
          editor,
        })
        if (headerValue) {
          items.push({
            type: 'menuitem',
            text: label,
            onAction: () => insertTemplate(editor, headerHtml),
          })
        }
      })

      return items
    },
  }

  headers.push(headersMenu)
}
